import React, { useEffect, useRef } from 'react';
import { CloseButton } from 'react-bootstrap';

import { useLocalization } from '../contexts/LocalizationContext';
import { useNotifications } from '../hooks/useNotifications';

export default function NotificationManager() {
  const { items, remove } = useNotifications();

  return (
    <div
      className='d-flex flex-column justify-content-start align-items-start'
      style={{
        position: 'fixed',
        bottom: '0.5rem',
        left: '0.5rem',
        marginRight: '0.5rem',
        zIndex: '1100',
        minWidth: '20rem',
        maxWidth: 'calc(100vw- 2rem)',
        overflowY: 'auto',
        maxHeight: '100vh',
        gap: '0.25rem'
      }}>
      {items.map((notification) => (
        <Notification
          key={notification.notificationId}
          remove={() => remove(notification.notificationId)}
          data={notification}
        />
      ))}
    </div>
  );
}

export function Notification({ data, remove }) {
  const { localize } = useLocalization();
  const timer = useRef();

  useEffect(() => {
    if (data?.timeout) {
      timer.current = setTimeout(() => {
        clearTimeout(timer.current);
        remove();
      }, data.timeout * 1000);
    }

    return () => clearTimeout(timer.current);
  }, [data]);

  return (
    <div
      className={`rounded bg-dark text-light px-4 py-3 ${
        data.variant ? `border-start border-5 border-${data.variant}` : ''
      }`}>
      <div className='position-relative'>
        <div className='me-5 d-flex'>
          {data.icon && <div className='me-3'>{data.icon}</div>}
          <div
            className='text-break'
            role={data.variant === 'danger' ? 'alert' : 'status'}
            aria-live={data.variant === 'danger' ? 'assertive' : 'polite'}
            aria-atomic='true'>
            {data.localize
              ? localize(data.content, { editable: false })
              : data.content}
          </div>
        </div>
        <CloseButton
          variant='white'
          onClick={remove}
          style={{
            position: 'absolute',
            right: '0',
            top: '50%',
            transform: 'translateY(-50%)'
          }}
        />
      </div>
    </div>
  );
}
